import React from 'react';
import { Card } from '@material-ui/core';
import { Icon } from 'fpay-ui';
import { useTranslation } from 'react-i18next';

import { capitalize, getTypeToShow } from '@helpers/utils';
import { getEnv } from '@config';
import { isCountryPeru } from 'constants/regions';
import { extractCciFromBankAccount } from 'helpers/bankAccount';
import classes from './ShowAccountData.module.scss';
import Button from '../Forms/Button';

const { publicPath } = getEnv();

const ShowAccountData = ({
  bankAccount,
  handleDelete,
  handleEdit,
  style,
  childCard,
  showModifyBankAccount,
}) => {
  const { t } = useTranslation();
  const accountType = bankAccount.account_data.account_type_code.toLowerCase();
  let accountTypeText = accountType;

  if (['cc', 'cv', '08', '01', '15', '02', '04', 'ca'].indexOf(accountType) > -1) {
    accountTypeText = t(
      `paymentsFoundsOut.common.${bankAccount.account_data.account_type_code.toLowerCase()}`
    );
  }
  const classesCard = [classes.card];
  if (childCard) classesCard.push(classes.childCard);
  const cci = isCountryPeru && extractCciFromBankAccount(bankAccount);

  return (
    <Card className={classesCard.join(' ')} style={{ ...style }}>
      <div className={classes.middle}>
        <h4 className={classes.title}>{t('paymentsFoundsOut.bankAccountCard.title')}</h4>
        {showModifyBankAccount && (
          <div className={classes.accountButtons}>
            <Button
              id="edit-account"
              data-testid="show-account-button-edit"
              onClick={handleEdit}
              variant="text"
            >
              <Icon icon="ic-edit-alt" width="24px" height="24px" />
            </Button>
            <Button
              id="delete-account"
              data-testid="show-account-button-delete"
              onClick={handleDelete}
              variant="text"
            >
              <Icon icon="ic-delete-alt" width="24px" height="24px" />
            </Button>
          </div>
        )}
      </div>
      <div className={classes.accountInfo}>
        <div className={classes.image}>
          <img src={`${publicPath}/ic_bank_18.svg`} alt="" />
        </div>
        <div className={classes.info}>
          <h5 id="doc-type" className={classes.bank}>
            {bankAccount.owner_data.doc_type}: {bankAccount.owner_data.doc_number}
          </h5>
          <h5 id="bank-name" className={classes.bank}>
            {capitalize(bankAccount.bank_data.finantial_institution_name)}
            {isCountryPeru && <span> - CCI: {cci}</span>}
          </h5>
          <p className={classes.bank}>
            <span id="account-type">{getTypeToShow(accountTypeText)}</span>
            <span>&nbsp;:&nbsp;</span>
            <span id="account-number" className={classes.accountNumber}>
              {bankAccount.account_data.account_number}
            </span>
          </p>
        </div>
      </div>
    </Card>
  );
};

export default ShowAccountData;
